<div class="grid">
  <div class="col-10">
    <h2 class="mb-0">Crear cuenta</h2>
    <p>{{ selectedRol }}</p>

    <div class="information">
      <img
        src="../../../../../../../assets/img/register/check-account.png"
        alt=""
      />
      <span
        >Su registro ha sido exitoso. Pronto recibirá un correo electrónico para
        validar su cuenta.</span
      >
    </div>
    <div class="flex justify-content-center mt-4">
      <a
        href="https://mail.google.com/mail"
        target="_blank"
        class="gmail-link no-underline"
      >
        <div class="flex align-items-center p-3 border-round-lg gmail-button">
          <div
            class="mail-icon flex align-items-center justify-content-center mr-3"
          >
            <i class="pi pi-envelope text-white text-xl"></i>
          </div>
          <div class="flex flex-column">
            <span class="text-lg font-medium text-color"
              >Verificar mi correo</span
            >
            <span class="text-sm text-color-secondary">Ir a Gmail ahora</span>
          </div>
          <div
            class="flex align-items-center justify-content-center ml-2 arrow-icon"
          >
            <i class="pi pi-arrow-right"></i>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
